import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { SiteFormResponse } from 'app/_models/site-forms/site-form-response.model';
import { FileService } from 'app/_services/file.service';
import { PdfExportService } from 'app/_services/pdf-export.service';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { SiteService } from 'app/_services/site.service';

@Component({
  selector: 'site-forms-response',
  templateUrl: './site-forms-response.component.html',
})
export class SiteFormsResponseComponent implements OnInit {
  public routeRole: any;
  public siteFormId: any;
  public siteFormResponse: SiteFormResponse;
  public logoUrl: string;
  public includePhotos: boolean = true;
  public workOrderId;
  public downloadClicked = false;

  public isLoading = true;

  private responseId: any;
  private siteOwnerLogin: string;

  constructor(
    private siteFormService: SiteFormsService,
    private siteService: SiteService,
    private pdfExportService: PdfExportService,
    private fileService: FileService,
    public activatedRoute: ActivatedRoute,
    private globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;

    this.activatedRoute.params.subscribe((params: Params) => {
      this.siteFormId = params.id;
      this.responseId = params.responseId;
    });
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.workOrderId = params.workOrderId;
    });
  }

  ngOnInit() {
    this.siteFormService.getSiteFormReponse(this.responseId).subscribe(data => {
      this.siteFormResponse = data;

      this.siteService.getSiteById(data.site.id).subscribe((data: any) => {
        this.siteOwnerLogin = data.siteOwner.login;
        this.logoUrl = this.siteFormService.getSiteOwnerLogo(this.siteOwnerLogin);
        this.isLoading = false;
      });
    });
  }

  public async downloadPDF() {
    this.downloadClicked = true; // when images are present, downloading a second time can cause an error - prevent double download
    this.pdfExportService.createPdfFromSiteFormResponse(this.siteFormResponse, this.logoUrl, this.includePhotos);
  }

  public openAttachment(file) {
    this.fileService.showFile(this.globals.fileFolder.siteFormResponseFiles, file);
  }
}
